import { useContext } from 'react'
import { AuthContext } from './auth-context'

export function useAuthUser () {
  return useContext(AuthContext)
}
